export const PERMISSIONS = {
  BOOKING: {
    CREATE: 'BOOKING_REQUEST',
    EDIT: 'EDIT_BOOKING',
    CANCEL: 'CANCEL_BOOKING',
    CREATE_BOOKING: 'CREATE_BOOKING',
  },
  PRECONFIRM_BOOKING: {
    CREATE: 'PRE_CONFIRM_BOOKING',
  },
  CIRCUIT_BOOKING: {
    CREATE: 'CIRCUIT_BOOKING',
  },
  CALENDAR: {
    VIEW: 'CALENDAR'
  },
  BOOKING_HISTORY: {
    VIEW: 'BOOKING_HISTORY',
  },
  PAYROLL_REPORT: {
    VIEW: 'PAYROLL_REPORT',
  },
  INSIGHTS: {
    VIEW: 'INSIGHTS',
  },
  MY_LIST: {
    VIEW: 'MY_LIST',
    COMPATIBLE_ACTION:'COMPATIBLE_ACTION',
    LEAST_COMPATIBLE: 'LEAST_COMPATIBLE',
  },
  SMART_GROUPS: {
    VIEW: 'SMART_GROUP',
    CREATE_SMART_GROUP: 'SMART_GROUP_CREATE',
    SMART_GROUP_ACTION: 'SMART_GROUP_ACTION',
    ADD_TO_LIST: 'ADD_TO_LIST',
  },
  FIND_NEW_TEACHER: {
    VIEW: 'FIND_NEW_TEACHER',
    FNT_SEND_INVITE: 'FNT_SEND_INVITE',
  },
  BOOKING_CONFIRMATION: {
    CREATE: 'BOOKING_CONFIRMATION',
    ACTION: 'BOOKING_CONFIRMATION_ACTION',
  },
  INVITE: {
    VIEW: 'INVITE',
  },
  REQUEST: {
    VIEW: 'REQUEST',
  },
  HUB_AND_SPOKE: {
    VIEW: 'HUB_AND_SPOKE',
  },
  SCHOOL_PROFILE: {
    VIEW: 'SCHOOL_PROFILE',
    EDIT: 'SCHOOL_PROFILE_WRITE',
  },
  MANAGE_TEAM: {
    VIEW: 'MANAGE_TEAM',
    EDIT: 'MANAGE_TEAM',
  },
  EDIT_BOOKING: {
    EDIT: 'EDIT_BOOKING',
  },
  NOTE_ACTIONS: {
    EDIT: 'NOTE_ACTION',
  },
  MY_LIST_ACTION: {
    EDIT: 'MY_LIST_ACTION',

  },
  CANCEL_BOOKING: {
    EDIT: 'CANCEL_BOOKING',
  },

} as const; 
